export const AI_VISIBILITY_LIST_PAGE_SIZE = 5;

export function getListRangeLabel(page, pageSize, total) {
	if (total === 0) return "0 of 0";
	const start = page * pageSize + 1;
	const end = Math.min((page + 1) * pageSize, total);
	return `${start}–${end} of ${total}`;
}
